export const IDENTIFIER_TYPES = {
  SODATONE: 'sodatone',
  OPUS: 'opus',
  ARTIST_PACK: 'artist_packs',
  SPOTIFY: 'spotify',
  INSTAGRAM: 'instagram',
  TIKTOK: 'tiktok',
  YOUTUBE: 'youtube',
};

export const DATA_TOOLS_ORDER = ['Opus', 'Sodatone', 'Artist Pack'];
export const SOCIALS_ORDER = ['spotify', 'youtube', 'tiktok', 'instagram'];
